// Fields that ride alongside content but are NOT content — excluding them keeps
// broadcasting a regenerated artifact from perturbing the content hash.
const EXCLUDED_SETTING_KEYS = [
  "contentPointer",
  "publicContentPointer",
  "previewContentHash",
];

const stableStringify = (value: unknown): string => {
  if (value === null || typeof value !== "object") {
    return JSON.stringify(value) ?? "null";
  }
  if (Array.isArray(value)) {
    return `[${value.map(stableStringify).join(",")}]`;
  }
  const obj = value as Record<string, unknown>;
  const keys = Object.keys(obj).sort();
  return `{${keys
    .map((k) => `${JSON.stringify(k)}:${stableStringify(obj[k])}`)
    .join(",")}}`;
};

// cyrb53 — fast, dependency-free 53-bit string hash (low collision rate).
const cyrb53 = (str: string, seed = 0): string => {
  let h1 = 0xdeadbeef ^ seed;
  let h2 = 0x41c6ce57 ^ seed;
  for (let i = 0; i < str.length; i++) {
    const ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  const out = 4294967296 * (2097151 & h2) + (h1 >>> 0);
  return out.toString(16);
};

export const hashStoryContent = ({
  slides,
  settings,
}: {
  slides: unknown;
  settings?: Record<string, unknown> | null;
}): string => {
  const filtered: Record<string, unknown> = { ...(settings || {}) };
  for (const key of EXCLUDED_SETTING_KEYS) delete filtered[key];
  return cyrb53(stableStringify({ slides, settings: filtered }));
};
